module.exports = __webpack_public_path__ + "988b8aed28f8e209a2a6441da00fc140.png";